import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { getPrivatePensionTotal } from 'routes/probate-estate/fact-find/get-totals'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import { PRIVATE_PENSION_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import RecordsSection, { RecordsSubSectionProps } from './records-section'

const PrivatePensions = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => (
  <RecordsSection
    heading="2.9 Private pensions"
    cardType="Pension"
    addLabel="Add pension"
    toggleName="privatePensionsSectionActive"
    sectionActive={sectionActive}
    saveProbateEstateField={saveProbateEstateField}
    collection={collection}
    schema={PRIVATE_PENSION_SCHEMA}
    totals={{
      total: getPrivatePensionTotal(collection.items as ProbateEstateItem[]),
    }}
    renderFields={({ handleSave }) => (
      <>
        <Grid.Item span={12}>
          <InputFloating
            name="providerName"
            label="Provider name"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={12}>
          <InputFloating
            name="referenceNumber"
            label="Policy or reference number"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={12}>
          <InputFloating
            name="value"
            label="Value (£)"
            isCurrency
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default PrivatePensions
